import { extendTheme } from "components-lib";
import { CardComponent } from "./additions/card/card";
import { buttonStyles } from "./components/button";
import { badgeStyles } from "./components/badge";
import { inputStyles } from "./components/input";
import { progressStyles } from "./components/progress";
import { sliderStyles } from "./components/slider";
import { textareaStyles } from "./components/textarea";
import { switchStyles } from "./components/switch";
import { linkStyles } from "./components/link";
import { globalStyles } from "./styles";

const config = {
  initialColorMode: "light",
  useSystemColorMode: false,
};

const theme = extendTheme({
  config,
  styles: globalStyles.styles,
  colors: globalStyles.colors,
  components: {
    ...badgeStyles.components,
    ...buttonStyles.components,
    ...linkStyles.components,
    ...progressStyles.components,
    ...sliderStyles.components,
    ...inputStyles.components,
    ...textareaStyles.components,
    ...switchStyles.components,
    ...CardComponent.components,
  },
  breakpoints: {
    sm: "320px",
    "2sm": "380px",
    md: "768px",
    lg: "960px",
    xl: "1200px",
    "2xl": "1600px",
    "3xl": "1920px",
  },
});

export default theme;
